export class History {
  createdByUser: string = '';
  createdDateTime: string = '';
  updatedByUser?: any = '';
  updatedDateTime?: any = '';
  revisionNumber: number = 0;
}
